import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
const path = window.location.pathname;

// Route /dashboard and /profile/* to the React app
// Route /login to the React app in login mode
// Route / (root) to the landing page
if (path === '/' || path === '') {
  window.location.replace('/landing.html');
} else {
  root.render(
    <React.StrictMode>
      <App initialPath={path} />
    </React.StrictMode>
  );
}
